/*
 * GARAGEM MODERNA - BASE DE VEICULOS BRASIL
 * ------------------------------------------------------------
 * Format: { brand: 'Make', model: 'Model', from: 2020, to: 2026 }
 * O seletor gera automaticamente os anos entre "from" e "to".
 *
 * Base ampliada com modelos populares, seminovos e modelos atuais do Brasil.
 * For vehicles outside the list, the selector still offers "Other make"
 * and "Other model", with years from 1980 to the current year.
 *
 * IMPORTANTE: mantenha aqui apenas veiculos para os quais sua operacao
 * consegue fornecer a aplicacao correta do produto.
 */
window.vehicleData = [
  { brand: 'Chevrolet', model: 'Agile', from: 2009, to: 2014 },
  { brand: 'Chevrolet', model: 'Astra', from: 1999, to: 2011 },
  { brand: 'Chevrolet', model: 'Blazer', from: 1995, to: 2011 },
  { brand: 'Chevrolet', model: 'Blazer EV', from: 2025, to: 2026 },
  { brand: 'Chevrolet', model: 'Bolt EV', from: 2019, to: 2023 },
  { brand: 'Chevrolet', model: 'Captiva', from: 2008, to: 2017 },
  { brand: 'Chevrolet', model: 'Captiva EV', from: 2026, to: 2026 },
  { brand: 'Chevrolet', model: 'Celta', from: 2000, to: 2016 },
  { brand: 'Chevrolet', model: 'Classic', from: 2003, to: 2016 },
  { brand: 'Chevrolet', model: 'Cobalt', from: 2011, to: 2020 },
  { brand: 'Chevrolet', model: 'Corsa Hatch', from: 1994, to: 2012 },
  { brand: 'Chevrolet', model: 'Corsa Sedan', from: 1995, to: 2012 },
  { brand: 'Chevrolet', model: 'Cruze', from: 2011, to: 2023 },
  { brand: 'Chevrolet', model: 'Equinox', from: 2018, to: 2026 },
  { brand: 'Chevrolet', model: 'Kadett', from: 1989, to: 1998 },
  { brand: 'Chevrolet', model: 'Meriva', from: 2002, to: 2012 },
  { brand: 'Chevrolet', model: 'Montana', from: 2003, to: 2026 },
  { brand: 'Chevrolet', model: 'Monza', from: 1982, to: 1996 },
  { brand: 'Chevrolet', model: 'Omega', from: 1992, to: 2012 },
  { brand: 'Chevrolet', model: 'Onix', from: 2012, to: 2026 },
  { brand: 'Chevrolet', model: 'Onix Plus', from: 2019, to: 2026 },
  { brand: 'Chevrolet', model: 'Prisma', from: 2006, to: 2019 },
  { brand: 'Chevrolet', model: 'S10', from: 1995, to: 2026 },
  { brand: 'Chevrolet', model: 'Sonic', from: 2012, to: 2014 },
  { brand: 'Chevrolet', model: 'Spark EUV', from: 2026, to: 2026 },
  { brand: 'Chevrolet', model: 'Spin', from: 2012, to: 2026 },
  { brand: 'Chevrolet', model: 'Tracker', from: 2001, to: 2026 },
  { brand: 'Chevrolet', model: 'Trailblazer', from: 2012, to: 2026 },
  { brand: 'Chevrolet', model: 'Vectra', from: 1997, to: 2011 },
  { brand: 'Chevrolet', model: 'Zafira', from: 2001, to: 2012 },

  { brand: 'Volkswagen', model: 'Amarok', from: 2010, to: 2026 },
  { brand: 'Volkswagen', model: 'Bora', from: 2000, to: 2011 },
  { brand: 'Volkswagen', model: 'CrossFox', from: 2005, to: 2017 },
  { brand: 'Volkswagen', model: 'Fox', from: 2003, to: 2021 },
  { brand: 'Volkswagen', model: 'Fusca', from: 2013, to: 2016 },
  { brand: 'Volkswagen', model: 'Gol', from: 1980, to: 2023 },
  { brand: 'Volkswagen', model: 'Golf', from: 1995, to: 2020 },
  { brand: 'Volkswagen', model: 'ID.4', from: 2023, to: 2026 },
  { brand: 'Volkswagen', model: 'Jetta', from: 2006, to: 2026 },
  { brand: 'Volkswagen', model: 'Kombi', from: 1980, to: 2013 },
  { brand: 'Volkswagen', model: 'New Beetle', from: 1999, to: 2010 },
  { brand: 'Volkswagen', model: 'Nivus', from: 2020, to: 2026 },
  { brand: 'Volkswagen', model: 'Parati', from: 1982, to: 2012 },
  { brand: 'Volkswagen', model: 'Passat', from: 1995, to: 2019 },
  { brand: 'Volkswagen', model: 'Polo', from: 2002, to: 2026 },
  { brand: 'Volkswagen', model: 'Santana', from: 1984, to: 2006 },
  { brand: 'Volkswagen', model: 'Saveiro', from: 1982, to: 2026 },
  { brand: 'Volkswagen', model: 'SpaceFox', from: 2006, to: 2019 },
  { brand: 'Volkswagen', model: 'T-Cross', from: 2019, to: 2026 },
  { brand: 'Volkswagen', model: 'Taos', from: 2021, to: 2026 },
  { brand: 'Volkswagen', model: 'Tera', from: 2025, to: 2026 },
  { brand: 'Volkswagen', model: 'Tiguan', from: 2009, to: 2026 },
  { brand: 'Volkswagen', model: 'Touareg', from: 2004, to: 2018 },
  { brand: 'Volkswagen', model: 'Up!', from: 2014, to: 2021 },
  { brand: 'Volkswagen', model: 'Virtus', from: 2018, to: 2026 },
  { brand: 'Volkswagen', model: 'Voyage', from: 2008, to: 2023 },

  { brand: 'Fiat', model: '500', from: 2009, to: 2017 },
  { brand: 'Fiat', model: 'Argo', from: 2017, to: 2026 },
  { brand: 'Fiat', model: 'Bravo', from: 2010, to: 2016 },
  { brand: 'Fiat', model: 'Cronos', from: 2018, to: 2026 },
  { brand: 'Fiat', model: 'Doblò', from: 2001, to: 2021 },
  { brand: 'Fiat', model: 'Fastback', from: 2022, to: 2026 },
  { brand: 'Fiat', model: 'Fiorino', from: 1995, to: 2026 },
  { brand: 'Fiat', model: 'Freemont', from: 2011, to: 2016 },
  { brand: 'Fiat', model: 'Grand Siena', from: 2012, to: 2021 },
  { brand: 'Fiat', model: 'Idea', from: 2005, to: 2016 },
  { brand: 'Fiat', model: 'Linea', from: 2008, to: 2016 },
  { brand: 'Fiat', model: 'Marea', from: 1998, to: 2007 },
  { brand: 'Fiat', model: 'Mobi', from: 2016, to: 2026 },
  { brand: 'Fiat', model: 'Palio', from: 1996, to: 2018 },
  { brand: 'Fiat', model: 'Palio Weekend', from: 1997, to: 2020 },
  { brand: 'Fiat', model: 'Pulse', from: 2021, to: 2026 },
  { brand: 'Fiat', model: 'Punto', from: 2007, to: 2017 },
  { brand: 'Fiat', model: 'Siena', from: 1997, to: 2016 },
  { brand: 'Fiat', model: 'Stilo', from: 2003, to: 2011 },
  { brand: 'Fiat', model: 'Strada', from: 1998, to: 2026 },
  { brand: 'Fiat', model: 'Tempra', from: 1992, to: 1999 },
  { brand: 'Fiat', model: 'Tipo', from: 1995, to: 1997 },
  { brand: 'Fiat', model: 'Titano', from: 2024, to: 2026 },
  { brand: 'Fiat', model: 'Toro', from: 2016, to: 2026 },
  { brand: 'Fiat', model: 'Uno', from: 1984, to: 2021 },

  { brand: 'Ford', model: 'Bronco Sport', from: 2021, to: 2026 },
  { brand: 'Ford', model: 'Courier', from: 1997, to: 2013 },
  { brand: 'Ford', model: 'EcoSport', from: 2003, to: 2021 },
  { brand: 'Ford', model: 'Edge', from: 2008, to: 2020 },
  { brand: 'Ford', model: 'Escort', from: 1995, to: 2003 },
  { brand: 'Ford', model: 'F-150', from: 2023, to: 2026 },
  { brand: 'Ford', model: 'Fiesta', from: 1996, to: 2019 },
  { brand: 'Ford', model: 'Focus', from: 2000, to: 2019 },
  { brand: 'Ford', model: 'Fusion', from: 2006, to: 2020 },
  { brand: 'Ford', model: 'Ka', from: 1997, to: 2021 },
  { brand: 'Ford', model: 'Ka Sedan', from: 2014, to: 2021 },
  { brand: 'Ford', model: 'Maverick', from: 2022, to: 2026 },
  { brand: 'Ford', model: 'Mondeo', from: 1995, to: 2006 },
  { brand: 'Ford', model: 'Mustang', from: 1995, to: 2026 },
  { brand: 'Ford', model: 'Ranger', from: 1998, to: 2026 },
  { brand: 'Ford', model: 'Territory', from: 2020, to: 2026 },

  { brand: 'Toyota', model: 'Camry', from: 2007, to: 2026 },
  { brand: 'Toyota', model: 'Corolla', from: 1993, to: 2026 },
  { brand: 'Toyota', model: 'Corolla Cross', from: 2021, to: 2026 },
  { brand: 'Toyota', model: 'Corolla Fielder', from: 2004, to: 2008 },
  { brand: 'Toyota', model: 'Etios Hatch', from: 2012, to: 2021 },
  { brand: 'Toyota', model: 'Etios Sedan', from: 2012, to: 2021 },
  { brand: 'Toyota', model: 'Hilux', from: 1995, to: 2026 },
  { brand: 'Toyota', model: 'Prius', from: 2013, to: 2021 },
  { brand: 'Toyota', model: 'RAV4', from: 2000, to: 2026 },
  { brand: 'Toyota', model: 'SW4', from: 1997, to: 2026 },
  { brand: 'Toyota', model: 'Yaris Cross', from: 2026, to: 2026 },
  { brand: 'Toyota', model: 'Yaris Hatch', from: 2018, to: 2026 },
  { brand: 'Toyota', model: 'Yaris Sedan', from: 2018, to: 2026 },

  { brand: 'Honda', model: 'Accord', from: 1998, to: 2024 },
  { brand: 'Honda', model: 'City', from: 2009, to: 2026 },
  { brand: 'Honda', model: 'City Hatchback', from: 2022, to: 2026 },
  { brand: 'Honda', model: 'Civic', from: 1992, to: 2026 },
  { brand: 'Honda', model: 'CR-V', from: 2000, to: 2026 },
  { brand: 'Honda', model: 'Fit', from: 2003, to: 2021 },
  { brand: 'Honda', model: 'HR-V', from: 2015, to: 2026 },
  { brand: 'Honda', model: 'WR-V', from: 2017, to: 2026 },
  { brand: 'Honda', model: 'ZR-V', from: 2023, to: 2026 },

  { brand: 'Hyundai', model: 'Azera', from: 2008, to: 2020 },
  { brand: 'Hyundai', model: 'Creta', from: 2017, to: 2026 },
  { brand: 'Hyundai', model: 'Elantra', from: 2011, to: 2018 },
  { brand: 'Hyundai', model: 'HB20', from: 2012, to: 2026 },
  { brand: 'Hyundai', model: 'HB20S', from: 2013, to: 2026 },
  { brand: 'Hyundai', model: 'HB20X', from: 2013, to: 2022 },
  { brand: 'Hyundai', model: 'i30', from: 2009, to: 2016 },
  { brand: 'Hyundai', model: 'Ioniq 5', from: 2024, to: 2026 },
  { brand: 'Hyundai', model: 'ix35', from: 2010, to: 2022 },
  { brand: 'Hyundai', model: 'Kona', from: 2024, to: 2026 },
  { brand: 'Hyundai', model: 'Santa Fe', from: 2007, to: 2026 },
  { brand: 'Hyundai', model: 'Tucson', from: 2005, to: 2026 },
  { brand: 'Hyundai', model: 'Veloster', from: 2011, to: 2013 },
  { brand: 'Hyundai', model: 'Veracruz', from: 2007, to: 2012 },

  { brand: 'Renault', model: 'Boreal', from: 2026, to: 2026 },
  { brand: 'Renault', model: 'Captur', from: 2017, to: 2023 },
  { brand: 'Renault', model: 'Clio', from: 1999, to: 2017 },
  { brand: 'Renault', model: 'Duster', from: 2011, to: 2026 },
  { brand: 'Renault', model: 'Fluence', from: 2011, to: 2018 },
  { brand: 'Renault', model: 'Kardian', from: 2024, to: 2026 },
  { brand: 'Renault', model: 'Kwid', from: 2017, to: 2026 },
  { brand: 'Renault', model: 'Logan', from: 2007, to: 2023 },
  { brand: 'Renault', model: 'Mégane', from: 1998, to: 2013 },
  { brand: 'Renault', model: 'Oroch', from: 2015, to: 2026 },
  { brand: 'Renault', model: 'Sandero', from: 2007, to: 2022 },
  { brand: 'Renault', model: 'Scénic', from: 1999, to: 2010 },
  { brand: 'Renault', model: 'Symbol', from: 2009, to: 2013 },

  { brand: 'Nissan', model: 'Frontier', from: 2002, to: 2026 },
  { brand: 'Nissan', model: 'Kicks', from: 2016, to: 2026 },
  { brand: 'Nissan', model: 'Leaf', from: 2019, to: 2023 },
  { brand: 'Nissan', model: 'Livina', from: 2009, to: 2014 },
  { brand: 'Nissan', model: 'March', from: 2011, to: 2020 },
  { brand: 'Nissan', model: 'Pathfinder', from: 2005, to: 2014 },
  { brand: 'Nissan', model: 'Sentra', from: 2007, to: 2026 },
  { brand: 'Nissan', model: 'Tiida', from: 2007, to: 2013 },
  { brand: 'Nissan', model: 'Versa', from: 2011, to: 2026 },
  { brand: 'Nissan', model: 'X-Trail', from: 2005, to: 2013 },

  { brand: 'Jeep', model: 'Cherokee', from: 2014, to: 2022 },
  { brand: 'Jeep', model: 'Commander', from: 2021, to: 2026 },
  { brand: 'Jeep', model: 'Compass', from: 2012, to: 2026 },
  { brand: 'Jeep', model: 'Grand Cherokee', from: 2011, to: 2026 },
  { brand: 'Jeep', model: 'Renegade', from: 2015, to: 2026 },
  { brand: 'Jeep', model: 'Wrangler', from: 2007, to: 2026 },

  { brand: 'Peugeot', model: '2008', from: 2015, to: 2026 },
  { brand: 'Peugeot', model: '206', from: 1999, to: 2010 },
  { brand: 'Peugeot', model: '207', from: 2008, to: 2015 },
  { brand: 'Peugeot', model: '208', from: 2013, to: 2026 },
  { brand: 'Peugeot', model: '3008', from: 2011, to: 2026 },
  { brand: 'Peugeot', model: '306', from: 1995, to: 2002 },
  { brand: 'Peugeot', model: '307', from: 2002, to: 2012 },
  { brand: 'Peugeot', model: '308', from: 2012, to: 2019 },
  { brand: 'Peugeot', model: '408', from: 2011, to: 2019 },
  { brand: 'Peugeot', model: '5008', from: 2018, to: 2026 },
  { brand: 'Peugeot', model: 'Partner', from: 1999, to: 2026 },

  { brand: 'Citroën', model: 'Aircross', from: 2011, to: 2021 },
  { brand: 'Citroën', model: 'Basalt', from: 2024, to: 2026 },
  { brand: 'Citroën', model: 'C3', from: 2003, to: 2026 },
  { brand: 'Citroën', model: 'C3 Aircross', from: 2024, to: 2026 },
  { brand: 'Citroën', model: 'C4', from: 2009, to: 2014 },
  { brand: 'Citroën', model: 'C4 Cactus', from: 2018, to: 2024 },
  { brand: 'Citroën', model: 'C4 Lounge', from: 2013, to: 2021 },
  { brand: 'Citroën', model: 'C4 Pallas', from: 2007, to: 2013 },
  { brand: 'Citroën', model: 'C4 Picasso', from: 2008, to: 2018 },
  { brand: 'Citroën', model: 'C5', from: 2001, to: 2012 },
  { brand: 'Citroën', model: 'Grand C4 Picasso', from: 2008, to: 2018 },
  { brand: 'Citroën', model: 'Xsara Picasso', from: 2001, to: 2012 },

  { brand: 'Mitsubishi', model: 'Airtrek', from: 2003, to: 2008 },
  { brand: 'Mitsubishi', model: 'ASX', from: 2011, to: 2023 },
  { brand: 'Mitsubishi', model: 'Eclipse Cross', from: 2018, to: 2026 },
  { brand: 'Mitsubishi', model: 'L200 Triton', from: 2008, to: 2026 },
  { brand: 'Mitsubishi', model: 'Lancer', from: 2008, to: 2019 },
  { brand: 'Mitsubishi', model: 'Outlander', from: 2008, to: 2026 },
  { brand: 'Mitsubishi', model: 'Pajero', from: 1998, to: 2021 },
  { brand: 'Mitsubishi', model: 'Pajero Sport', from: 2007, to: 2026 },

  { brand: 'Kia', model: 'Bongo', from: 2005, to: 2026 },
  { brand: 'Kia', model: 'Carens', from: 2008, to: 2012 },
  { brand: 'Kia', model: 'Carnival', from: 2001, to: 2026 },
  { brand: 'Kia', model: 'Cerato', from: 2009, to: 2022 },
  { brand: 'Kia', model: 'Mohave', from: 2009, to: 2017 },
  { brand: 'Kia', model: 'Niro', from: 2022, to: 2026 },
  { brand: 'Kia', model: 'Picanto', from: 2006, to: 2020 },
  { brand: 'Kia', model: 'Rio', from: 2020, to: 2022 },
  { brand: 'Kia', model: 'Sorento', from: 2005, to: 2024 },
  { brand: 'Kia', model: 'Soul', from: 2009, to: 2020 },
  { brand: 'Kia', model: 'Sportage', from: 2005, to: 2026 },

  { brand: 'Chery', model: 'Arrizo 5', from: 2019, to: 2022 },
  { brand: 'Chery', model: 'Celer', from: 2013, to: 2018 },
  { brand: 'Chery', model: 'QQ', from: 2011, to: 2019 },
  { brand: 'Chery', model: 'Tiggo 2', from: 2018, to: 2022 },
  { brand: 'Chery', model: 'Tiggo 5X', from: 2019, to: 2026 },
  { brand: 'Chery', model: 'Tiggo 7', from: 2019, to: 2026 },
  { brand: 'Chery', model: 'Tiggo 8', from: 2020, to: 2026 },

  { brand: 'Caoa Chery', model: 'Arrizo 6', from: 2020, to: 2023 },
  { brand: 'Caoa Chery', model: 'Tiggo 3X', from: 2021, to: 2022 },
  { brand: 'Caoa Chery', model: 'Tiggo 5X', from: 2019, to: 2026 },
  { brand: 'Caoa Chery', model: 'Tiggo 7', from: 2019, to: 2026 },
  { brand: 'Caoa Chery', model: 'Tiggo 8', from: 2020, to: 2026 },

  { brand: 'BYD', model: 'Dolphin', from: 2023, to: 2026 },
  { brand: 'BYD', model: 'Dolphin Mini', from: 2024, to: 2026 },
  { brand: 'BYD', model: 'Han', from: 2022, to: 2026 },
  { brand: 'BYD', model: 'King', from: 2024, to: 2026 },
  { brand: 'BYD', model: 'Seal', from: 2023, to: 2026 },
  { brand: 'BYD', model: 'Shark', from: 2024, to: 2026 },
  { brand: 'BYD', model: 'Song Plus', from: 2022, to: 2026 },
  { brand: 'BYD', model: 'Song Premium', from: 2025, to: 2026 },
  { brand: 'BYD', model: 'Song Pro', from: 2024, to: 2026 },
  { brand: 'BYD', model: 'Tan', from: 2022, to: 2026 },
  { brand: 'BYD', model: 'Yuan Plus', from: 2022, to: 2026 },
  { brand: 'BYD', model: 'Yuan Pro', from: 2024, to: 2026 },

  { brand: 'GWM', model: 'Haval H6', from: 2023, to: 2026 },
  { brand: 'GWM', model: 'Haval H6 GT', from: 2023, to: 2026 },
  { brand: 'GWM', model: 'Haval H9', from: 2025, to: 2026 },
  { brand: 'GWM', model: 'Ora 03', from: 2023, to: 2026 },
  { brand: 'GWM', model: 'Tank 300', from: 2025, to: 2026 },

  { brand: 'RAM', model: '1500', from: 2021, to: 2026 },
  { brand: 'RAM', model: '2500', from: 2005, to: 2026 },
  { brand: 'RAM', model: '3500', from: 2022, to: 2026 },
  { brand: 'RAM', model: 'Rampage', from: 2023, to: 2026 },

  { brand: 'Suzuki', model: 'Grand Vitara', from: 1998, to: 2016 },
  { brand: 'Suzuki', model: 'Jimny', from: 1998, to: 2026 },
  { brand: 'Suzuki', model: 'S-Cross', from: 2015, to: 2022 },
  { brand: 'Suzuki', model: 'Vitara', from: 2017, to: 2022 },

  { brand: 'Volvo', model: 'EX30', from: 2024, to: 2026 },
  { brand: 'Volvo', model: 'XC40', from: 2018, to: 2026 },
  { brand: 'Volvo', model: 'XC60', from: 2009, to: 2026 },
  { brand: 'Volvo', model: 'XC90', from: 2003, to: 2026 },

  { brand: 'Land Rover', model: 'Discovery Sport', from: 2015, to: 2026 },
  { brand: 'Land Rover', model: 'Freelander 2', from: 2007, to: 2015 },
  { brand: 'Land Rover', model: 'Range Rover Evoque', from: 2012, to: 2026 },

  { brand: 'JAC', model: 'E-JS1', from: 2021, to: 2026 },
  { brand: 'JAC', model: 'T40', from: 2018, to: 2022 },
  { brand: 'JAC', model: 'T50', from: 2018, to: 2022 },
  { brand: 'JAC', model: 'T60', from: 2020, to: 2022 },

  { brand: 'Subaru', model: 'Forester', from: 1998, to: 2026 },
  { brand: 'Subaru', model: 'Impreza', from: 1998, to: 2026 },
  { brand: 'Subaru', model: 'XV', from: 2012, to: 2023 },

  { brand: 'BMW', model: 'Série 1', from: 2009, to: 2026 },
  { brand: 'BMW', model: 'Série 3', from: 2005, to: 2026 },
  { brand: 'BMW', model: 'Série 5', from: 2005, to: 2026 },
  { brand: 'BMW', model: 'X1', from: 2010, to: 2026 },
  { brand: 'BMW', model: 'X2', from: 2018, to: 2026 },
  { brand: 'BMW', model: 'X3', from: 2005, to: 2026 },
  { brand: 'BMW', model: 'X5', from: 2005, to: 2026 },

  { brand: 'Mercedes-Benz', model: 'CLA', from: 2014, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'Classe A', from: 2013, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'Classe C', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'Classe E', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'GLA', from: 2015, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'GLC', from: 2016, to: 2026 },

  { brand: 'Audi', model: 'A3', from: 2005, to: 2026 },
  { brand: 'Audi', model: 'A4', from: 2005, to: 2026 },
  { brand: 'Audi', model: 'Q3', from: 2012, to: 2026 },
  { brand: 'Audi', model: 'Q5', from: 2009, to: 2026 },

  // ------------------------------------------------------------
  // CAR VEXO - UK EXPANSION
  // Existing vehicle options above are intentionally preserved.
  // Added common UK used cars, high-volume road cars and current models.
  // Sources used for prioritisation: SMMT Motorparc / used-car / registration data.
  // ------------------------------------------------------------

  // Vauxhall (UK-market Opel branding)
  { brand: 'Vauxhall', model: 'Astra', from: 1998, to: 2026 },
  { brand: 'Vauxhall', model: 'Corsa', from: 2000, to: 2026 },
  { brand: 'Vauxhall', model: 'Crossland', from: 2017, to: 2024 },
  { brand: 'Vauxhall', model: 'Grandland', from: 2018, to: 2026 },
  { brand: 'Vauxhall', model: 'Insignia', from: 2008, to: 2022 },
  { brand: 'Vauxhall', model: 'Mokka', from: 2013, to: 2026 },
  { brand: 'Vauxhall', model: 'Zafira', from: 1999, to: 2018 },

  // MINI
  { brand: 'MINI', model: 'Aceman', from: 2024, to: 2026 },
  { brand: 'MINI', model: 'Clubman', from: 2007, to: 2024 },
  { brand: 'MINI', model: 'Cooper', from: 2001, to: 2026 },
  { brand: 'MINI', model: 'Countryman', from: 2010, to: 2026 },
  { brand: 'MINI', model: 'Hatch', from: 2001, to: 2024 },
  { brand: 'MINI', model: 'Paceman', from: 2013, to: 2016 },

  // Skoda
  { brand: 'Skoda', model: 'Enyaq', from: 2021, to: 2026 },
  { brand: 'Skoda', model: 'Fabia', from: 2000, to: 2026 },
  { brand: 'Skoda', model: 'Kamiq', from: 2019, to: 2026 },
  { brand: 'Skoda', model: 'Karoq', from: 2017, to: 2026 },
  { brand: 'Skoda', model: 'Kodiaq', from: 2017, to: 2026 },
  { brand: 'Skoda', model: 'Octavia', from: 1998, to: 2026 },
  { brand: 'Skoda', model: 'Scala', from: 2019, to: 2026 },
  { brand: 'Skoda', model: 'Superb', from: 2002, to: 2026 },

  // SEAT
  { brand: 'SEAT', model: 'Arona', from: 2017, to: 2026 },
  { brand: 'SEAT', model: 'Ateca', from: 2016, to: 2026 },
  { brand: 'SEAT', model: 'Ibiza', from: 1999, to: 2026 },
  { brand: 'SEAT', model: 'Leon', from: 2000, to: 2026 },
  { brand: 'SEAT', model: 'Tarraco', from: 2019, to: 2024 },

  // CUPRA
  { brand: 'CUPRA', model: 'Ateca', from: 2018, to: 2024 },
  { brand: 'CUPRA', model: 'Born', from: 2022, to: 2026 },
  { brand: 'CUPRA', model: 'Formentor', from: 2020, to: 2026 },
  { brand: 'CUPRA', model: 'Leon', from: 2020, to: 2026 },
  { brand: 'CUPRA', model: 'Tavascan', from: 2024, to: 2026 },
  { brand: 'CUPRA', model: 'Terramar', from: 2024, to: 2026 },

  // MG
  { brand: 'MG', model: 'HS', from: 2019, to: 2026 },
  { brand: 'MG', model: 'MG3', from: 2013, to: 2026 },
  { brand: 'MG', model: 'MG4 EV', from: 2022, to: 2026 },
  { brand: 'MG', model: 'MG5 EV', from: 2020, to: 2025 },
  { brand: 'MG', model: 'ZS', from: 2017, to: 2026 },

  // Tesla
  { brand: 'Tesla', model: 'Model 3', from: 2019, to: 2026 },
  { brand: 'Tesla', model: 'Model S', from: 2014, to: 2026 },
  { brand: 'Tesla', model: 'Model X', from: 2016, to: 2026 },
  { brand: 'Tesla', model: 'Model Y', from: 2022, to: 2026 },

  // Dacia
  { brand: 'Dacia', model: 'Duster', from: 2013, to: 2026 },
  { brand: 'Dacia', model: 'Jogger', from: 2022, to: 2026 },
  { brand: 'Dacia', model: 'Sandero', from: 2013, to: 2026 },
  { brand: 'Dacia', model: 'Spring', from: 2024, to: 2026 },

  // Lexus
  { brand: 'Lexus', model: 'CT', from: 2011, to: 2020 },
  { brand: 'Lexus', model: 'IS', from: 2005, to: 2021 },
  { brand: 'Lexus', model: 'LBX', from: 2024, to: 2026 },
  { brand: 'Lexus', model: 'NX', from: 2014, to: 2026 },
  { brand: 'Lexus', model: 'RX', from: 2005, to: 2026 },
  { brand: 'Lexus', model: 'UX', from: 2019, to: 2026 },

  // Jaguar
  { brand: 'Jaguar', model: 'E-Pace', from: 2018, to: 2024 },
  { brand: 'Jaguar', model: 'F-Pace', from: 2016, to: 2026 },
  { brand: 'Jaguar', model: 'I-Pace', from: 2018, to: 2024 },
  { brand: 'Jaguar', model: 'XE', from: 2015, to: 2024 },
  { brand: 'Jaguar', model: 'XF', from: 2008, to: 2024 },

  // Porsche
  { brand: 'Porsche', model: '911', from: 2005, to: 2026 },
  { brand: 'Porsche', model: 'Cayenne', from: 2003, to: 2026 },
  { brand: 'Porsche', model: 'Macan', from: 2014, to: 2026 },
  { brand: 'Porsche', model: 'Panamera', from: 2009, to: 2026 },
  { brand: 'Porsche', model: 'Taycan', from: 2020, to: 2026 },

  // Newer high-volume UK entrants
  { brand: 'JAECOO', model: '5', from: 2025, to: 2026 },
  { brand: 'JAECOO', model: '7', from: 2024, to: 2026 },
  { brand: 'OMODA', model: '5', from: 2024, to: 2026 },
  { brand: 'OMODA', model: '9', from: 2025, to: 2026 },
  { brand: 'Polestar', model: '2', from: 2020, to: 2026 },
  { brand: 'Polestar', model: '3', from: 2024, to: 2026 },
  { brand: 'Polestar', model: '4', from: 2024, to: 2026 },

  // Ford - UK additions (existing Ford options retained)
  { brand: 'Ford', model: 'Capri', from: 2024, to: 2026 },
  { brand: 'Ford', model: 'Fiesta', from: 2020, to: 2023 },
  { brand: 'Ford', model: 'Focus', from: 2020, to: 2025 },
  { brand: 'Ford', model: 'Galaxy', from: 1995, to: 2023 },
  { brand: 'Ford', model: 'Kuga', from: 2008, to: 2026 },
  { brand: 'Ford', model: 'Puma', from: 2019, to: 2026 },
  { brand: 'Ford', model: 'S-Max', from: 2006, to: 2023 },

  // Volkswagen - UK additions
  { brand: 'Volkswagen', model: 'Golf', from: 2021, to: 2026 },
  { brand: 'Volkswagen', model: 'ID.3', from: 2020, to: 2026 },
  { brand: 'Volkswagen', model: 'ID.5', from: 2022, to: 2026 },
  { brand: 'Volkswagen', model: 'Passat', from: 2020, to: 2026 },
  { brand: 'Volkswagen', model: 'Sharan', from: 1995, to: 2022 },
  { brand: 'Volkswagen', model: 'T-Roc', from: 2018, to: 2026 },
  { brand: 'Volkswagen', model: 'Touran', from: 2003, to: 2026 },

  // Nissan - UK additions
  { brand: 'Nissan', model: 'Ariya', from: 2022, to: 2026 },
  { brand: 'Nissan', model: 'Juke', from: 2010, to: 2026 },
  { brand: 'Nissan', model: 'Micra', from: 2003, to: 2023 },
  { brand: 'Nissan', model: 'Qashqai', from: 2007, to: 2026 },
  { brand: 'Nissan', model: 'X-Trail', from: 2014, to: 2026 },

  // Toyota - UK additions
  { brand: 'Toyota', model: 'Aygo', from: 2005, to: 2022 },
  { brand: 'Toyota', model: 'Aygo X', from: 2022, to: 2026 },
  { brand: 'Toyota', model: 'C-HR', from: 2017, to: 2026 },
  { brand: 'Toyota', model: 'Yaris', from: 2000, to: 2026 },

  // BMW - British model naming, while Portuguese-labelled existing options remain
  { brand: 'BMW', model: '1 Series', from: 2004, to: 2026 },
  { brand: 'BMW', model: '2 Series', from: 2014, to: 2026 },
  { brand: 'BMW', model: '3 Series', from: 2005, to: 2026 },
  { brand: 'BMW', model: '4 Series', from: 2013, to: 2026 },
  { brand: 'BMW', model: '5 Series', from: 2005, to: 2026 },
  { brand: 'BMW', model: 'i3', from: 2013, to: 2022 },
  { brand: 'BMW', model: 'i4', from: 2021, to: 2026 },
  { brand: 'BMW', model: 'iX', from: 2021, to: 2026 },
  { brand: 'BMW', model: 'iX1', from: 2022, to: 2026 },
  { brand: 'BMW', model: 'X4', from: 2014, to: 2026 },
  { brand: 'BMW', model: 'X6', from: 2008, to: 2026 },

  // Mercedes-Benz - British model naming
  { brand: 'Mercedes-Benz', model: 'A-Class', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'B-Class', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'C-Class', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'E-Class', from: 2005, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'EQA', from: 2021, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'EQB', from: 2021, to: 2026 },
  { brand: 'Mercedes-Benz', model: 'GLE', from: 2015, to: 2026 },

  // Audi - UK additions
  { brand: 'Audi', model: 'A1', from: 2010, to: 2026 },
  { brand: 'Audi', model: 'A5', from: 2007, to: 2026 },
  { brand: 'Audi', model: 'A6', from: 2005, to: 2026 },
  { brand: 'Audi', model: 'Q2', from: 2016, to: 2026 },
  { brand: 'Audi', model: 'Q4 e-tron', from: 2021, to: 2026 },
  { brand: 'Audi', model: 'Q7', from: 2006, to: 2026 },
  { brand: 'Audi', model: 'Q8', from: 2018, to: 2026 },
  { brand: 'Audi', model: 'e-tron', from: 2019, to: 2023 },

  // Kia - UK additions
  { brand: 'Kia', model: 'Ceed', from: 2007, to: 2026 },
  { brand: 'Kia', model: 'EV3', from: 2024, to: 2026 },
  { brand: 'Kia', model: 'EV6', from: 2021, to: 2026 },
  { brand: 'Kia', model: 'Picanto', from: 2021, to: 2026 },
  { brand: 'Kia', model: 'ProCeed', from: 2008, to: 2025 },
  { brand: 'Kia', model: 'Sorento', from: 2025, to: 2026 },
  { brand: 'Kia', model: 'Stonic', from: 2017, to: 2026 },
  { brand: 'Kia', model: 'XCeed', from: 2019, to: 2026 },

  // Hyundai - UK additions
  { brand: 'Hyundai', model: 'i10', from: 2008, to: 2026 },
  { brand: 'Hyundai', model: 'i20', from: 2009, to: 2026 },
  { brand: 'Hyundai', model: 'i30', from: 2017, to: 2026 },
  { brand: 'Hyundai', model: 'Ioniq', from: 2016, to: 2022 },
  { brand: 'Hyundai', model: 'Ioniq 6', from: 2023, to: 2026 },
  { brand: 'Hyundai', model: 'Kona', from: 2017, to: 2023 },

  // Peugeot - UK additions
  { brand: 'Peugeot', model: '308', from: 2020, to: 2026 },
  { brand: 'Peugeot', model: '408', from: 2023, to: 2026 },
  { brand: 'Peugeot', model: '508', from: 2011, to: 2026 },

  // Renault - UK additions
  { brand: 'Renault', model: 'Arkana', from: 2021, to: 2026 },
  { brand: 'Renault', model: 'Austral', from: 2022, to: 2026 },
  { brand: 'Renault', model: 'Captur', from: 2024, to: 2026 },
  { brand: 'Renault', model: 'Clio', from: 2018, to: 2026 },
  { brand: 'Renault', model: 'Scenic E-Tech', from: 2024, to: 2026 },
  { brand: 'Renault', model: 'Zoe', from: 2013, to: 2024 },

  // Citroen - UK additions
  { brand: 'Citroën', model: 'C1', from: 2005, to: 2022 },
  { brand: 'Citroën', model: 'C3 Aircross', from: 2017, to: 2023 },
  { brand: 'Citroën', model: 'C5 Aircross', from: 2018, to: 2026 },

  // Volvo - UK additions
  { brand: 'Volvo', model: 'S60', from: 2010, to: 2024 },
  { brand: 'Volvo', model: 'V40', from: 2012, to: 2019 },
  { brand: 'Volvo', model: 'V60', from: 2010, to: 2026 },
  { brand: 'Volvo', model: 'V90', from: 2016, to: 2025 },

  // Land Rover - UK additions
  { brand: 'Land Rover', model: 'Defender', from: 2020, to: 2026 },
  { brand: 'Land Rover', model: 'Discovery', from: 2005, to: 2026 },
  { brand: 'Land Rover', model: 'Range Rover', from: 2005, to: 2026 },
  { brand: 'Land Rover', model: 'Range Rover Sport', from: 2005, to: 2026 },
  { brand: 'Land Rover', model: 'Range Rover Velar', from: 2017, to: 2026 },

  // Honda - UK additions
  { brand: 'Honda', model: 'e:Ny1', from: 2023, to: 2026 },
  { brand: 'Honda', model: 'Jazz', from: 2002, to: 2026 },

  // Mazda (common UK models; brand not present in original list)
  { brand: 'Mazda', model: 'Mazda2', from: 2007, to: 2026 },
  { brand: 'Mazda', model: 'Mazda3', from: 2004, to: 2026 },
  { brand: 'Mazda', model: 'Mazda6', from: 2002, to: 2023 },
  { brand: 'Mazda', model: 'CX-3', from: 2015, to: 2022 },
  { brand: 'Mazda', model: 'CX-30', from: 2019, to: 2026 },
  { brand: 'Mazda', model: 'CX-5', from: 2012, to: 2026 },
  { brand: 'Mazda', model: 'MX-30', from: 2021, to: 2025 },

  // BYD - UK naming additions
  { brand: 'BYD', model: 'Atto 3', from: 2023, to: 2026 },
  { brand: 'BYD', model: 'Seal U', from: 2024, to: 2026 },
  { brand: 'BYD', model: 'Sealion 7', from: 2025, to: 2026 },

];
